import React, { useEffect, useState } from "react";
import projectData from "../../Data/projectData";
import { Link } from "react-router-dom";

const ProjectSection = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    setProjects(projectData);
  }, []);

  return (
    <div className="overflow-hidden space-top space-extra-bottom">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title6 justify-content-center">
            <span className="shape left">
              <span className="dots"></span>
            </span>
            OUR PROJECTS
            <span className="shape right">
              <span className="dots"></span>
            </span>
          </span>
          <h2 className="sec-title">Explore Our Client's Projects</h2>
        </div>

        <div className="row gy-4">
          {projects.map((project) => (
            <div key={project.id} className="col-xl-4 col-md-6">
              <div className="project-card style1-1">
                <div className="project-card-img">
                  <img
                    src={project.imgSrc}
                    alt="project imagee"
                    style={{ height: "320px" }}
                  />
                </div>
                <div
                  className="project-card-details"
                  data-bg-src="/assets/img/project/project-card-bg.png"
                >
                  <h4 className="box-title" style={{minHeight : "80px"}}>
                    <Link to="">{project.title}</Link>
                  </h4>
                  {/* <p className="project-card-content text-justify">
                    {project.description}
                  </p> */}
                  {/* <Link
                    to={project.imgLink}
                    className="th-btn style9"
                    tabIndex="-1"
                  >
                    Read More <i className="fas fa-arrow-right ms-1"></i>
                  </Link> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectSection;
